import { useState, useEffect, useRef } from "react";
import {
  Autocomplete,
  Grid,
  TextField,
  FormControl,
  DatePicker,
  Divider,
  Checkbox,
  FormControlLabel,
} from "../../../../components";
import {
  PessoaService,
  SessionService,
} from "../../../../services";
import { value } from "../../../../helpers";
import { responseErros, timeoutBuscaAutocomplete } from "../../../../utils";
import { useFiltrosRelatoriosHandlers } from "../../components/use-filtros-relatorios-handlers";
import GrupoPessoaService from "../../../../services/api/grupoPessoas.service";

const pessoaService = new PessoaService();
const sessionService = new SessionService();
const gruposPessoasService = new GrupoPessoaService();

const FormFiltroAvancadoVendas = ({
  filtrosAvancados,
  setFiltrosAvancados,
  filtrosAplicadosImpressao,
  setFiltrosAplicadosImpressao,
  setValidationError
}) => {
  const inputRefCliente = useRef();
  const inputRefVendedor = useRef();
  const [clienteList, setClienteList] = useState([]);
  const [vendedorList, setVendedorList] = useState([]);
  const [grupoPessoasList, setGrupoPessoasList] = useState([]);
  // const [condicaoPagamentoList, setCondicaoPagamentoList] = useState([]);
  // const [meioPagamentoList, setMeioPagamentoList] = useState([]);
  const [loadingAutoComplete, setLoadingAutoComplete] = useState(false);
  const usuario = sessionService.getUsuario();
  const empresa = sessionService.getEmpresa();
  const { onChangeAutocomplete, onChangeDate, onChangeCheckbox } =
    useFiltrosRelatoriosHandlers(
      setFiltrosAvancados,
      setFiltrosAplicadosImpressao
    );

  useEffect(() => {
    setEstadoInicial();
    // buscarCondicoesPagamento();
    // buscarMeiosPagamento();
    buscarGruposPessoas();
  }, []);

  function setEstadoInicial() {
    const filtros = {
      ...filtrosAvancados,
      empresasIds: [empresa.id],
    };
    let filtrosImpressao = {};
    if (usuario.acessosEmpresas?.length) {
      filtrosImpressao = {
        ...filtrosAplicadosImpressao,
        ["Empresas-Associadas"]: empresa.razaoSocial,
      };
    }

    setFiltrosAvancados(filtros);
    setFiltrosAplicadosImpressao(filtrosImpressao);
  }

  const buscarClientes = () => {
    const filtros = {
      nonPaginated: true,
      tiposPessoaId: 1,
    };
    pessoaService.getAll(filtros).then((result) => {
      if (!result.isAxiosError) {
        setClienteList(result.data);
      } else {
        responseErros(result);
      }
    });
    setLoadingAutoComplete(false);
  };

  const buscarVendedores = () => {
    const filtro = {
      nonPaginated: true,
      vendedor: true,
      tiposPessoaId: 4,
    };
    pessoaService.getAll(filtro).then((result) => {
      if (!result.isAxiosError) {
        setVendedorList(result.data);
      } else {
        responseErros(result);
      }
    });
    setLoadingAutoComplete(false);
  };

  // const buscarCondicoesPagamento = () => {
  //   condicaoPagamentoService.getAll({ ativado: true }).then((result) => {
  //     if (!result.isAxiosError) {
  //       setCondicaoPagamentoList(result.data.rows);
  //     } else {
  //       responseErros(result);
  //     }
  //   });
  // };

  // const buscarMeiosPagamento = () => {
  //   meioPagamentoService.getAll({ ativado: true }).then((result) => {
  //     if (!result.isAxiosError) {
  //       setMeioPagamentoList(result.data.rows);
  //     } else {
  //       responseErros(result);
  //     }
  //   });
  // };

  const buscarGruposPessoas = () => {
    const filter = {
      nonPaginated: true,
      ativado: true,
      tipoPessoa: 4
    };
    gruposPessoasService.getAll(filter).then((res) => {
      if (!res.isAxiosError) {
        setGrupoPessoasList(res.data);
      } else {
        responseErros(res);
      }
    });
  };

  const onInputChangePessoa = (event, tiposPessoaId) => {
    const inputRefMap = {
      1: {
        inputRef: inputRefCliente,
        buscar: buscarClientes,
      },
      4: {
        inputRef: inputRefVendedor,
        buscar: buscarVendedores,
      },
    };
    const { inputRef, buscar } = inputRefMap[tiposPessoaId] || {};
    if (
      event.key === "Enter" &&
      inputRef?.current === document.activeElement &&
      event.target?.value?.length > 2
    ) {
      setLoadingAutoComplete(true);
      const filtros = {
        nomeRazaoSocial: event.target.value,
        apelidoFantasia: event.target.value,
      };
      timeoutBuscaAutocomplete(buscar?.(filtros));
    }
  };

  function onChangeMultipleEmpresas(empresas) {
    setFiltrosAvancados((prevState) => ({
      ...prevState,
      empresasIds: empresas.map(({ id }) => id),
    }));
    setFiltrosAplicadosImpressao((prevState) => ({
      ...prevState,
      "Empresas-Associadas": empresas
        .map(({ razaoSocial }) => razaoSocial)
        .join(" | "),
    }));
  }

  return (
    <>
      {usuario.acessosEmpresas?.length > 0 && (
        <>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Autocomplete
              multiple
              id="empresasIds"
              name="empresasIds"
              options={usuario.acessosEmpresas}
              noOptionsText="Sem opções"
              autoHighlight
              disablePortal
              filterSelectedOptions
              getOptionLabel={(option) => option?.razaoSocial || ""}
              onChange={(_, newValue) => onChangeMultipleEmpresas(newValue)}
              value={value.multiple(
                usuario.acessosEmpresas || [],
                filtrosAvancados["empresasIds"]
                  ? filtrosAvancados["empresasIds"]
                  : ""
              )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  required
                  label="Empresas"
                  margin="normal"
                />
              )}
            />
          </Grid>
        </Grid>
        <Divider sx={{ mt: 2, mb: 1, border: "1px solid grey" }}/>
        </>
      )}
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <FormControl variant="outlined" margin="normal" fullWidth>
            <Autocomplete
              id="clienteId"
              name="Cliente"
              options={clienteList}
              autoHighlight
              disablePortal
              getOptionLabel={(option) => option?.nomeRazaoSocial ?? ""}
              getOptionSelected={(option, value) =>
                option?.nomeRazaoSocial === value?.nomeRazaoSocial
              }
              loading={loadingAutoComplete}
              loadingText="Carregando"
              noOptionsText="Digite e pressione Enter"
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Cliente"
                  variant="outlined"
                  onKeyDown={(e) => onInputChangePessoa(e, 1)}
                  inputRef={inputRefCliente}
                  InputProps={{
                    ...params.InputProps,
                  }}
                />
              )}
              onChange={(e, value) =>
                onChangeAutocomplete("clienteId", value, "Cliente")
              }
              value={value.autoComplete(
                clienteList,
                filtrosAvancados?.clienteId
              )}
            />
          </FormControl>
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <FormControl variant="outlined" margin="normal" fullWidth>
            <Autocomplete
              id="vendedorId"
              name="Vendedor"
              options={vendedorList}
              autoHighlight
              disablePortal
              getOptionLabel={(option) => option?.nomeRazaoSocial ?? ""}
              getOptionSelected={(option, value) =>
                option?.nomeRazaoSocial === value?.nomeRazaoSocial
              }
              loading={loadingAutoComplete}
              loadingText="Carregando"
              noOptionsText="Digite e pressione Enter"
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Vendedor"
                  variant="outlined"
                  onKeyDown={(e) => onInputChangePessoa(e, 4)}
                  inputRef={inputRefVendedor}
                  InputProps={{
                    ...params.InputProps,
                  }}
                />
              )}
              onChange={(e, value) =>
                onChangeAutocomplete("vendedorId", value, "Vendedor")
              }
              value={value.autoComplete(
                vendedorList,
                filtrosAvancados?.vendedorId
              )}
            />
          </FormControl>
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <FormControl variant="outlined" margin="normal" fullWidth>
            <Autocomplete
              id="grupoPessoaId"
              name="grupoPessoaId"
              options={grupoPessoasList}
              autoHighlight
              disablePortal
              getOptionLabel={(option) => option?.nome ?? ""}
              getOptionSelected={(option, value) =>
                option?.nome === value?.nome
              }
              loading={loadingAutoComplete}
              loadingText="Carregando"
              noOptionsText="Digite e pressione Enter"
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Grupo de Pessoas"
                  variant="outlined"
                  InputProps={{
                    ...params.InputProps,
                  }}
                />
              )}
              onChange={(e, value) =>
                onChangeAutocomplete("grupoPessoaId", value, "Grupo-de-Pessoas")
              }
              value={value.autoComplete(
                grupoPessoasList,
                filtrosAvancados?.grupoPessoaId
              )}
            />
          </FormControl>
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <DatePicker
            id="dataLancamentoStart"
            name="Data-Emissão-De"
            label="Data de Emissão De"
            margin
            format="dd/MM/yyyy"
            value={value.date(filtrosAvancados?.dataLancamentoStart)}
            onChange={(date) =>
              onChangeDate("dataLancamentoStart", date, "Data-Emissão-De")
            }
            slotProps={{
              popper: { sx: { zIndex: 2000 }, }
            }}
            setError={setValidationError}
          />
        </Grid>
        <Grid item xs={6}>
          <DatePicker
            id="dataLancamentoEnd"
            name="Data-Emissão-Até"
            label="Data de Emissão Até"
            margin
            format="dd/MM/yyyy"
            value={value.date(filtrosAvancados?.dataLancamentoEnd)}
            onChange={(date) =>
              onChangeDate("dataLancamentoEnd", date, "Data-Emissão-Até")
            }
            slotProps={{
              popper: { sx: { zIndex: 2000 }, }
            }}
            setError={setValidationError}
          />
        </Grid>
      </Grid>
        {/* <Grid container spacing={2}>
          <Grid item xs={6}>
            <FormControl variant="outlined" margin="normal" fullWidth>
              <Autocomplete
                id="condicaoPagamentoId"
                name="Condição-de-Pagamento"
                options={condicaoPagamentoList}
                autoHighlight
                disablePortal
                getOptionLabel={(option) =>
                  option.id && option.descricao
                    ? `${option.id} - ${option.descricao}`
                    : ""
                }
                getOptionSelected={(option, value) =>
                  option?.descricao === value?.descricao
                }
                noOptionsText="Sem opções"
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Condição de Pagamento"
                    variant="outlined"
                  />
                )}
                onChange={(e, value) =>
                  onChangeAutocomplete(
                    "condicaoPagamentoId",
                    value,
                    "Condição-de-Pagamento"
                  )
                }
                value={value.autoComplete(
                  condicaoPagamentoList,
                  filtrosAvancados?.condicaoPagamentoId
                )}
              />
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <FormControl variant="outlined" margin="normal" fullWidth>
              <Autocomplete
                id="meioPagamentoId"
                name="Meio-de-Pagamento"
                options={meioPagamentoList}
                autoHighlight
                disablePortal
                getOptionLabel={(option) =>
                  option.id && option.descricao
                    ? `${option.id} - ${option.descricao}`
                    : ""
                }
                getOptionSelected={(option, value) =>
                  option?.descricao === value?.descricao
                }
                noOptionsText="Sem opções"
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Meios de pagamento"
                    variant="outlined"
                  />
                )}
                onChange={(e, value) =>
                  onChangeAutocomplete(
                    "meioPagamentoId",
                    value,
                    "Meio-de-Pagamento"
                  )
                }
                value={value.autoComplete(
                  meioPagamentoList,
                  filtrosAvancados?.meioPagamentoId
                )}
              />
            </FormControl>
          </Grid>
        </Grid> */}
      {empresa?.moduloServico && (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <FormControlLabel
              label="Considerar Ordem de Serviço"
              labelPlacement="end"
              control={
                <Checkbox
                  name="ordemServico"
                  checked={filtrosAvancados?.ordemServico || false}
                  onChange={(event) => onChangeCheckbox(event, "Ordem-Servico")}
                  color="primary"
                />
              }
            />
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default FormFiltroAvancadoVendas;
